import { render, staticRenderFns } from "./rest_configuration.vue?vue&type=template&id=27e134cb&"
import script from "./rest_configuration.vue?vue&type=script&lang=js&"
export * from "./rest_configuration.vue?vue&type=script&lang=js&"
import style0 from "./rest_configuration.vue?vue&type=style&index=0&id=27e134cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports